import { SelectionCard } from '~/components/selection-card-new/selection-card';
import { StyledExtendedSelectionGroup } from '~/components/selection-card-new/styles/extended-selection-group-styles';
import { RenderHtml } from '~/components/text';
import { SelectionCardItem } from '~/graphql/types';

export interface ExtendedSelectionGroupProps {
	items: SelectionCardItem[];
	withImage?: boolean;
	type: 'multi-select' | 'single-select';
}

export const ExtendedSelectionGroupWrapper: React.FC<ExtendedSelectionGroupProps> = ({ items, withImage, type }) => {
	const selectionType = items.length === 1 ? 'multi-select' : type;

	return (
		<StyledExtendedSelectionGroup>
			{items.map((card) => (
				<SelectionCard id={card.key} key={card.name} item={card} type={selectionType} withImage={withImage}>
					{card.description && <RenderHtml html={card.description} />}
				</SelectionCard>
			))}
		</StyledExtendedSelectionGroup>
	);
};
